import { createContext } from 'react'

const bulkContext = createContext()

export default bulkContext
